import accountHelper from "@/utils/helpers/account";

const fullName = account => accountHelper.fullName(account);

const isLegal = account => account.accountable_type == "Legal";

const isProfessional = account => account.accountable_type == "Professional";

const isPhysical = account => account.accountable_type == "Physical";
export default {
  filters: {
    fullName
  },
  methods: {
    isLegal,
    isProfessional,
    isPhysical
  }
};



// WEBPACK FOOTER //
// ./src/mixins/accountMixin.js